module.exports = __webpack_public_path__ + "static/media/delivery.5a51b87c.svg";